import React from "react";
import DatePicker from "react-datepicker";
import premiums from "./premiums.json";
import { t } from "../../utils/i18n";

const DefaultForm = ({
  selectedGender,
  dateOfBirth,
  selectedPremium,
  mode,
  submitting,
  nonTerminalIllness,
  validationErrors,
  submit,
  handleChange,
  onChangeDateOfBirth
}) => (
  <form noValidate>
    <div className="form-row">
      <div className="form-group col-md-6 gender required">
        <label className="form-label">{t("referrals.insurance_calc.your_gender")}</label>
        <select
          className="form-control"
          value={selectedGender}
          onChange={e => handleChange(e, "selectedGender")}
        >
          <option value="male">{t("referrals.insurance_calc.male")}</option>
          <option value="female">{t("referrals.insurance_calc.female")}</option>
        </select>
      </div>
      <div className="form-group col-md-6 date-of-birth required">
        <label className="form-label">{t("referrals.insurance_calc.your_dob")}</label>
        <DatePicker
          className={`form-control ${
            validationErrors?.dateOfBirthError ? "is-invalid" : ""
          }`}
          required="required"
          selected={dateOfBirth}
          onChange={e => onChangeDateOfBirth(e)}
          dateFormat="MMMM d, yyyy"
          placeholderText={t("referrals.insurance_calc.enter_dob")}
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          isClearable={true}
          todayButton={t("referrals.insurance_calc.today_button")}
          placeholderText={t("referrals.insurance_calc.click_select_date")}
          minDate={new Date().setFullYear(new Date().getFullYear() - 62)}
          maxDate={new Date().setFullYear(new Date().getFullYear() - 1)}
        />
        {validationErrors?.dateOfBirthError && (
          <div className="error text-danger">
            {validationErrors.dateOfBirthError}
          </div>
        )}
      </div>
    </div>
    <div className="form-group">
      <label className="form-label">{t("referrals.insurance_calc.your_premium_max")}</label>
      <div className="input-group mb-2">
        <div className="input-group-prepend">
          <div className="input-group-text">$</div>
        </div>

        <select
          className="form-control"
          value={selectedPremium}
          onChange={e => handleChange(e, "selectedPremium")}
        >
          {premiums.map((premium, i) => (
            <option key={i} value={premium.value}>
              {t("referrals.insurance_calc.per_year", { label: premium.label })}
            </option>
          ))}
        </select>
      </div>
    </div>
    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        checked={nonTerminalIllness}
        onChange={e => handleChange(e, "nonTerminalIllness")}
      />
      <label className="form-check-label text-muted">
        {t("referrals.insurance_calc.no_terminal")}
      </label>
    </div>
    {!nonTerminalIllness && (
      <div className="alert alert-warning" role="alert">
        {t("referrals.insurance_calc.terminal_warning")}
      </div>
    )}
    <div className="action">
      <button
        type="submit"
        className="btn btn-primary"
        disabled={!nonTerminalIllness || submitting}
        onClick={e => submit(e)}
      >
        {submitting && (
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        )}
        {t("referrals.insurance_calc.preview")}
      </button>
    </div>
  </form>
);

export default DefaultForm;
